export default __webpack_public_path__ + "static/media/azure-logo.d699486f.svg";